module.exports = __webpack_public_path__ + "static/media/CS2 --earlyLOMock.cb58aea1.png";